import { SmButton } from '@smiles/smiles-react-design-system';
import React from 'react';

import useApi from '@/hooks/useApi';
import useEvent from '@/hooks/useEvent';

import { TOptinContent } from '@/services/requests/Liferay/types';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';

import { getValue } from '@/helpers/GetValueHelper';

type TProps = {
  data: TOptinContent;
  onBack: () => void;
  onClose: () => void;
  onTryAgain: () => void;
};

export function ScreenError({ data, onBack, onClose, onTryAgain }: TProps) {
  const { ApiInteractions } = useApi();
  const event = useEvent();
  const defaultError = {
    title: 'Ops, algo deu errado.',
    description: `Tivemos um problema com nosso sistema e não conseguimos salvar as
    informações.Pode tentar mais uma vez?`,
    button: 'Tentar novamente',
  };

  const handlerButton = () => {
    dispatchInteraction(ApiInteractions, 'extra_optin_click_back_error', {
      recommendationId: event.data.recommendationId,
    });
    if (getValue(data, 'error.error_title', '')) {
      onBack();
    } else {
      onTryAgain();
    }
  };

  const handleClose = () => {
    dispatchInteraction(ApiInteractions, 'extra_optin_click_close', {
      recommendationId: event.data.recommendationId,
    });
    onClose();
  };

  return (
    <div className="smls-optin__modal-content">
      <div className="smls-optin__button--close">
        <SmButton
          onClick={handleClose}
          isPill
          isOutlined
          icon={<span className="material-icons">close</span>}
        />
      </div>
      <h4 className="smls-optin__title--error">
        {getValue(data, 'error.error_title', defaultError.title)}
      </h4>
      <p className="smls-optin__description--error">
        {getValue(data, 'error.error_description', defaultError.description)}
      </p>
      <SmButton
        className="smls-optin__button--send"
        onClick={handlerButton}
        text={getValue(data, 'error.error_button_label', defaultError.button)}
      />
    </div>
  );
}
